/**
 * Get total unread message count across all conversations
 */

import { getConversations } from './messages';

export const getUnreadMessageCount = async () => {
  try {
    const { data, error } = await getConversations();
    if (error || !data) {
      return 0;
    }
    
    // Sum up all unread counts
    const totalUnread = data.reduce((sum, conv) => sum + (conv.unread_count || 0), 0);
    return totalUnread;
  } catch (error) {
    console.error('Error getting unread message count:', error);
    return 0;
  }
};

